/* eslint-disable */
import jQuery from "jquery";
import Cookies from "js-cookie";

// Check if the cookie 'geoip-messaging-check-performed' exists
var geoipDismissedCookie = Cookies.get("geoip-messaging-check-performed");

if (!geoipDismissedCookie) {
  init();
}

// Show the GeoRouting message
function init() {
  // Get the current content Id from a data attribute on <body>
  var contentId = jQuery("body").data("content-id");

  // Make a fetch request
  fetch("/webApi/GeoRouting/GetGeoRoutingMessage?contentId=" + contentId, {
    method: "POST",
  })
    .then(function (response) {
      // Check if the response status is OK (200)
      if (response.status === 200) {
        return response.text(); // Parse the response body as text
      } else {
        throw new Error("Request failed with status: " + response.status);
      }
    })
    .then(function (htmlResponse) {
      // Append the response HTML to the end of the page
      var parser = new DOMParser();
      var doc = parser.parseFromString(htmlResponse, "text/html");
      var bodyContent = doc.querySelector("body").innerHTML;
      document.body.insertAdjacentHTML("beforeend", bodyContent);
      initCallback();
    })
    .catch(function (error) {
      console.error("Error:", error);
    });

  Cookies.set("geoip-messaging-check-performed", true, { expires: 30 });
}

// Called only if the GeoRouting message is displayed.
function initCallback() {
  // Handle the dismiss click
  jQuery(".js-geo-routing-dismiss").on("click", function (e) {
    e.preventDefault();
    jQuery(".location-switch__message").addClass("hidden");
  });
}
